import { render } from "./autoReply.vue?vue&type=template&id=d9ca06d2"
import script from "./autoReply.vue?vue&type=script&lang=js"
export * from "./autoReply.vue?vue&type=script&lang=js"

import "./autoReply.vue?vue&type=style&index=0&id=d9ca06d2&lang=scss"

import exportComponent from "/data/jenkins/workspace/b2c-im-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__